import { Currency, Segment, SegmentEntity, WithBaseEntitySchema } from '@40seas/models';
import { AtradiusCoverRequestStatus } from './atradius-cover-request.status';
import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const AtradiusCoverRequestSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        atradiusCompany: z.string(),
        requestedAmount: z.number().optional(),
        currency: z.string(),
        status: z.enum([AtradiusCoverRequestStatus.Decision, AtradiusCoverRequestStatus.ManualReview]),
        coverId: z.string().optional(),
    }),
).strict();

export class AtradiusCoverRequest extends FromSchema(AtradiusCoverRequestSchema) implements SegmentEntity {
    id: string;
    buyer: string;
    atradiusCompany: string;
    requestedAmount?: number;
    currency: Currency;
    status: AtradiusCoverRequestStatus;
    coverId?: string;
    createdAt?: Date;
    updatedAt?: Date;
    tenantId: string;
    segments?: Segment[];
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
    seller: string;
}
